import { render, staticRenderFns } from "./YlmsContent.vue?vue&type=template&id=27e8ac34&scoped=true&"
import script from "./YlmsContent.vue?vue&type=script&lang=ts&"
export * from "./YlmsContent.vue?vue&type=script&lang=ts&"
import style0 from "./YlmsContent.vue?vue&type=style&index=0&id=27e8ac34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e8ac34",
  null
  
)

export default component.exports